
  import {Component, Vue} from 'vue-property-decorator';
  import {IApp} from "@/interfaces/app.interface";
  import {formatDateForServer} from "@/plugins/moment";
  import {KeyboardMobileHidden} from "@/plugins/keyboard-mobile-hidden";
  import {ICamsPhoto} from "@/modules/Car/interfaces/cams-photo.interface";
  import {IAppMediaPopup} from "@/shared/AppMediaPopup/interfaces/app-media-popup.interface";
  import {bus} from "@/plugins/bus";
  import AppDatePicker from "@/components/FormControls/AppDatePicker.vue";
  import {ICar} from "@/modules/Car/interfaces/car.interface";
  import {ICarPopupTables} from "@/modules/Car/interfaces/car-popup-tables.interface";
  import {IAppState} from "@/interfaces/app-state.interface";

  @Component({
    components: {AppDatePicker}
  })
  export default class CarTableCameras extends Vue {
    format = IApp.DATE_FORMAT_ELEMENT_UI;
    dateFormats = IApp.DateFormats;
    loadingData = false;
    defaultValues = {
      dateBeg: '',
      dateEnd: '',
    };
    formModel = {
      dateBeg: '',
      dateEnd: '',
    };

    get storeState(): IAppState { return this.$store.state; }
    get activeCar(): ICar.IEntity { return this.storeState.car.activeCar; }
    get dateEmpty() { return !Boolean(this.formModel.dateBeg) && !Boolean(this.formModel.dateEnd); }
    get tableList(): ICarPopupTables.ICamerasTableItem[] {
      let tables = this.storeState.car.tables;
      if (!tables || (tables && !tables[ICarPopupTables.CarPopupTables.movHistory])) return [];
      return tables[ICarPopupTables.CarPopupTables.movHistory] || [];
    }

    async mounted() {
      bus.$on(IAppMediaPopup.EmitterEvents.ToggleEntityTo + IAppMediaPopup.MediaPopupSourceCall.CarPopupCameras,
        async ({ indexRow, direction }) => {
        let index = indexRow;
        if (direction === +1) index = indexRow === this.tableList.length - 1 ? 0 : indexRow + direction;
        else index = indexRow === 0 ? this.tableList.length - 1 : indexRow + direction;
        await this.openMediaPopup(this.tableList[index], index, true);
      });
    }

    async getData() {
      this.loadingData = true;

      let params: ICarPopupTables.ICarTableParams = {
        command: ICarPopupTables.Command.GetCameras,
        carNumber: this.activeCar.carNumber,
      };
      if (this.formModel.dateBeg) params.fltDateBeg = formatDateForServer(this.formModel.dateBeg, IApp.DateFormats.PrintedDate);
      if (this.formModel.dateEnd) params.fltDateEnd = formatDateForServer(this.formModel.dateEnd, IApp.DateFormats.PrintedDate);

      let success = await this.$store.dispatch('car/getTable', params);
      this.loadingData = false;
    }

    async prepareData() {
      if (!this.tableList.length) await this.getData();

      KeyboardMobileHidden();
    }

    async openMediaPopup(item: ICarPopupTables.ICamerasTableItem, index: number, fromPopup = false) {
      const resourcePayload: ICamsPhoto.IPayloadCams = {
        camId: item.camId,
        carNumber: this.activeCar.carNumber,
        dateEvent: item.camTime,
      };
      const { response } = await ICamsPhoto.GetCamsPhoto(resourcePayload);
      const mediaPayload: IAppMediaPopup.IPayload = {
        files: response && response.length ? response : [],
        parentList: {
          name: IAppMediaPopup.MediaPopupSourceCall.CarPopupCameras,
          currentIndex: index,
          total: this.tableList.length,
        },
        mediaInfo: {
          carNumber: this.activeCar.carNumber,
          props: [
            { cells: [
                { label: 'Дата: ', value: this.$options.filters.moment(item.camTime, IApp.DateFormats.PrintedDateTimeFull) },
              ]
            },
            { cells: [
                { label: 'Событие [считываний]: ', value: item.event },
              ]
            },
          ],
        }
      };
      this.$store.commit('car/setProperty', { name: 'displayContent', value: false });
      let savedCarId = this.activeCar.carId ? this.activeCar.carId : null;

      let payload = {
        ...mediaPayload,
        savePayloadData: {
          carId: savedCarId,
        },
        closeAction: () => {
          this.$store.commit('car/setProperty', { name: 'displayContent', value: true });
        }
      };

      if (!fromPopup) {
        await this.$store.dispatch('dialog/openDialog', {
          blockName: 'allPages',
          dialogName: 'appMediaPopup',
          payload,
        });
      }
      else {
        this.$store.commit('dialog/updateActivePopupPayload', payload);
        await this.$store.dispatch('dialog/reloadPopup');
      }
    }

    pickerShortcutAction(dates: { start?: string; end?: string; }) {
      if (dates.start) this.formModel.dateBeg = dates.start;
      if (dates.end) this.formModel.dateEnd = dates.end;
    }

    destroyed() {
      bus.$off(IAppMediaPopup.EmitterEvents.ToggleEntityTo + IAppMediaPopup.MediaPopupSourceCall.CarPopupCameras);
    }
  }
